module.exports = __webpack_public_path__ + "img/kv_sp.3e839ee.webp";